var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("vue-data-table", {
        attrs: {
          tableColumns: _vm.columns,
          tableRows: _vm.rows,
          isLoading: _vm.isLoading,
          showRowTableAction: false,
          "empty-rows-message": _vm.$t("components.table.no_data"),
        },
        on: _vm._d({}, [_vm.needDataUpdateEvent, _vm.init]),
        scopedSlots: _vm._u([
          {
            key: "table-row",
            fn: function (props) {
              return [
                ["dateEnd", "dateStart"].includes(props.cell.getColumn.id)
                  ? [
                      _c("formatted-date-component", {
                        attrs: { val: props.cell.getValue, withTime: true },
                      }),
                    ]
                  : ["attachments"].includes(props.cell.getColumn.id)
                  ? [
                      props.cell.getValue.length > 0
                        ? _c(
                            "div",
                            _vm._l(props.cell.getValue, function (attachment) {
                              return _c(
                                "div",
                                {
                                  key: attachment.key,
                                  staticClass: "description",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: { target: "_blank", href: "#" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.downLoadAttachment(
                                            attachment
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(attachment.name) + " "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          )
                        : _c("div", [_vm._v(" ")]),
                    ]
                  : [_c("span", [_vm._v(_vm._s(props.cell.getValue) + " ")])],
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }